function initStickyHeader() {
  const header = jQuery('.header');
  const navbarNav = jQuery('ul.primary-navigation__nav');
  const body = jQuery('body');

  if (!body.hasClass('header-static')) {
    if (jQuery(window).scrollTop() > 0) {
      header.addClass('fixed');
      navbarNav.addClass('fixed');
    } else {
      header.removeClass('fixed');
      navbarNav.removeClass('fixed');
    }
  }
}

jQuery(window).on('scroll', () => {
  initStickyHeader();
});

jQuery(() => {
  initStickyHeader();
});
